module.exports = __webpack_public_path__ + "02a53a5fef68875c7c1f37c9b265e105.png";